export const INITIAL_FOCUS_SELECTOR = '.ftv-magneto--skip-btn,[name="btn-play"],[name="btn-first-play"]';
export const LAST_FOCUSED_ELEMENT_EXCEPTIONS = [
  '.magneto-wrapper'
];
